export const ttNotifyUrl = `${TIKTOK_AD_DOMAIN}/ac/api/v1/oauth/bind_tt_oauth`;

export enum OauthResCode {
  // 成功
  SUCCESS = 0,
  // 邮箱用户未注册
  NOT_REGISTER = 1011,
  // 手机号未注册
  NOT_MOBILE_REGISTER = 1008,
  // 重置密码时手机号未注册
  MOBILE_NOT_REGISTER = 1054,
  // 账号或者密码错误
  WRONG_ACCOUNT_OR_PWD = 1009,
  // 限制登录
  NOT_SAFE_BLOCK_LOGIN = 7,
  // 滑块验证码为空,需要带上fp参数
  NEED_FINGER_PRINT = 1104,
  // 滑块验证码错误, 需要带上fp参数，验证码错误
  WRONG_FINGER_PRINT = 1105,
  // 3D点选验证码
  WRONG_3D = 1107,
  // 旋转验证码错误
  WRONG_WHIRL = 1108,
  // 帐号不安全，需要使用邮件验证码登录
  NOT_SAFE = 2013,
  // 触发安全验证
  SAFETY_VERIFY = 1039,
  // 邮箱未验证，需验证
  EMAIL_VERIFY = 1350,
  // 触发二次验证
  SAFATY_SECOND_VERIFY = 2046,
  // oauth 登录失败, 需走绑定流程
  OAUTH_LOGIN_FAIL = 1011,
  // oauth 绑定失败，账号已绑定其他TT账号。在返回此类型的报错后，需要从response中获取最新的 profile_key
  // 并填充到 ctx.store 中，因为出现此返回码说明上一个 profile_key 已被消耗
  OAUTH_BIND_ERROR_TT4B_BINDED = 1041,
  // oauth 登录绑定的时候报错，一种场景是当前 TT 与 TT4B 账户已存在绑定关系
  OAUTH_SWITCH_OR_BIND_NOT_ALLOWED = 1030,
  // oauth 注册失败，账号已在TT4B注册 -- 手机号注册用户
  OAUTH_BIND_ERROR_TT4B_REGISTER = 1001,
  // oauth 注册失败，账号已在TT4B注册 -- 邮箱注册用户
  OAUTH_BIND_ERROR_TT4B_REGISTER_EMAIL = 1023,
  // oauth session expired
  OAUTH_SESSION_EXPIRED = 1902,

  EMAIL_SEND_TOO_MUCH = 1206,
  NEED_EMAIL_VERIFY = 2033,
  NEED_MOBILE_VERIFY = 2032,
  NEED_PASSWORD_VERIFY = 2020,
}

export const APP_ID = 1583

export enum UserRegisterMode {
  old = 'old', // 老 SDK + 老流程
  only_form = 'only_form', // 新 SDK + 只表单注册
  only_tt = 'only_tt', // 新 SDK + 只 TT Oauth 注册
  form_and_tt = 'form_and_tt', // 新 SDK + 表单注册 + TT Oauth 注册
  form_and_tt_old_flow = 'form_and_tt_old_flow', // 新 SDK + 表单注册 + TT Oauth 注册 + 旧流程
}

// tt oauth 授权后携带的参数
export const registerUserTTOauthExtraQueries = ["_extra", "code", "scopes", "state", "isSkip", "log_id", "error_description", "error"]

export const emailTerms = {
  NEW_EVENT: 11,
  NEW_FEATURE: 17,
  PROMOTION: 12,
}
